import templateUrl from './drug-field.html';

function frmDrugField() {
  return {
    restrict: 'A',
    scope: {
      model: '=',
      required: '&'
    },
    templateUrl: templateUrl
  };
}

export default frmDrugField;



/** WEBPACK FOOTER **
 ** ./src/app/forms/fields/drug-field.directive.js
 **/